<!--<div>{{ options.chartHeader }}</div>-->

<ng-container *ngIf="resultsObserable | async as results; else loading;">


  <ngx-charts-line-chart *ngIf="results && results.length > 0"
                         style="padding:1px; fill: #2B2B2B;"
                         [view]="view | async"
                         [scheme]="scheme"
                         [legend]="legend"
                         [legendTitle]="legendTitle"
                         [showXAxisLabel]="showXAxisLabel"
                         [showYAxisLabel]="showYAxisLabel"
                         [xAxis]="xAxis"
                         [yAxis]="yAxis"
                         [xAxisLabel]="options.xAxisLabel"
                         [yAxisLabel]="options.yAxisLabel"
                         [timeline]="timeline"
                         [results]="results"
                         [curve]="curve"
                         (select)="onSelect($event)"
                         (activate)="onActivate($event)"
                         (deactivate)="onDeactivate($event)"
                         [xAxisTickFormatting]="options.xAxisTickFormatting">
    <ng-template *ngIf="eveTooltipTemplate != null" #tooltipTemplate let-model="model">
      <ng-container *ngTemplateOutlet="eveTooltipTemplate;context:{model}"></ng-container>
    </ng-template>

    <ng-template *ngIf="eveSeriesTooltipTemplate != null" #seriesTooltipTemplate let-model="model">
      <ng-container *ngTemplateOutlet="eveSeriesTooltipTemplate;context:{model}"></ng-container>
    </ng-template>
  </ngx-charts-line-chart>

  <div [innerHTML]="legendStyles | async">
  </div>

  <ng-container *ngIf="results.length == 0">
    <div style="margin-top: 135px; ">
      <img src="{{reportingUrl}}/Images/eveLogo.png" alt="eve Logo" style="opacity: 0.2; color: gray; display: block; margin: auto;" />
      <div style="color: #646965; text-align: center">no results found</div>
    </div>
  </ng-container>


</ng-container>

<ng-template #loading>
  <div style="color:gray; display: block; margin: auto;">
    <span *ngIf="!results" class="fa fa-spinner fa-pulse fa-5x" style=" color:gray;"></span>

  </div>
 </ng-template>

